module.exports = __webpack_public_path__ + "static/media/chokha7.80e255f2.webp";